"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingGroupApi = exports.SharingGroupApiFactory = exports.SharingGroupApiFp = exports.SharingGroupApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SharingGroupApi - axios parameter creator
 * @export
 */
const SharingGroupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create sharing group
         * @param {SharingGroupEditCreateInput} [sharingGroupEditCreateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSharingGroup: (sharingGroupEditCreateInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sharing-group/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sharingGroupEditCreateInput, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete sharing group
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSharingGroup: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteSharingGroup', 'id', id);
            const localVarPath = `/sharing-group/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Edit sharing group
         * @param {string} id
         * @param {SharingGroupEditCreateInput} [sharingGroupEditCreateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSharingGroup: (id, sharingGroupEditCreateInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('editSharingGroup', 'id', id);
            const localVarPath = `/sharing-group/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sharingGroupEditCreateInput, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all sharing groups
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSharingGroups: (filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sharing-group/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get sharing group by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharingGroupById: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSharingGroupById', 'id', id);
            const localVarPath = `/sharing-group/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get sharing group shared documents
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharingGroupSharedDocuments: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSharingGroupSharedDocuments', 'id', id);
            const localVarPath = `/sharing-group/{id}/shared/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Import contacts to sharing group from csv
         * @param {string} id
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importContactsToSharingGroupFromCsv: (id, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('importContactsToSharingGroupFromCsv', 'id', id);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('importContactsToSharingGroupFromCsv', 'file', file);
            const localVarPath = `/sharing-group/{id}/import-csv`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Unshare all documents with sharing group
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unshareAllDocumentsWithSharingGroup: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('unshareAllDocumentsWithSharingGroup', 'id', id);
            const localVarPath = `/sharing-group/{id}/unshare/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SharingGroupApiAxiosParamCreator = SharingGroupApiAxiosParamCreator;
/**
 * SharingGroupApi - functional programming interface
 * @export
 */
const SharingGroupApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SharingGroupApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create sharing group
         * @param {SharingGroupEditCreateInput} [sharingGroupEditCreateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSharingGroup(sharingGroupEditCreateInput, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSharingGroup(sharingGroupEditCreateInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete sharing group
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSharingGroup(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSharingGroup(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Edit sharing group
         * @param {string} id
         * @param {SharingGroupEditCreateInput} [sharingGroupEditCreateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSharingGroup(id, sharingGroupEditCreateInput, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editSharingGroup(id, sharingGroupEditCreateInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all sharing groups
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSharingGroups(filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllSharingGroups(filter, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get sharing group by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharingGroupById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSharingGroupById(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get sharing group shared documents
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharingGroupSharedDocuments(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSharingGroupSharedDocuments(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Import contacts to sharing group from csv
         * @param {string} id
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importContactsToSharingGroupFromCsv(id, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importContactsToSharingGroupFromCsv(id, file, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Unshare all documents with sharing group
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unshareAllDocumentsWithSharingGroup(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unshareAllDocumentsWithSharingGroup(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SharingGroupApiFp = SharingGroupApiFp;
/**
 * SharingGroupApi - factory interface
 * @export
 */
const SharingGroupApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SharingGroupApiFp)(configuration);
    return {
        /**
         *
         * @summary Create sharing group
         * @param {SharingGroupEditCreateInput} [sharingGroupEditCreateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSharingGroup(sharingGroupEditCreateInput, options) {
            return localVarFp.createSharingGroup(sharingGroupEditCreateInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete sharing group
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSharingGroup(id, options) {
            return localVarFp.deleteSharingGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit sharing group
         * @param {string} id
         * @param {SharingGroupEditCreateInput} [sharingGroupEditCreateInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSharingGroup(id, sharingGroupEditCreateInput, options) {
            return localVarFp.editSharingGroup(id, sharingGroupEditCreateInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all sharing groups
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSharingGroups(filter, options) {
            return localVarFp.getAllSharingGroups(filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get sharing group by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharingGroupById(id, options) {
            return localVarFp.getSharingGroupById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get sharing group shared documents
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharingGroupSharedDocuments(id, options) {
            return localVarFp.getSharingGroupSharedDocuments(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Import contacts to sharing group from csv
         * @param {string} id
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importContactsToSharingGroupFromCsv(id, file, options) {
            return localVarFp.importContactsToSharingGroupFromCsv(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unshare all documents with sharing group
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unshareAllDocumentsWithSharingGroup(id, options) {
            return localVarFp.unshareAllDocumentsWithSharingGroup(id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SharingGroupApiFactory = SharingGroupApiFactory;
/**
 * SharingGroupApi - object-oriented interface
 * @export
 * @class SharingGroupApi
 * @extends {BaseAPI}
 */
class SharingGroupApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create sharing group
     * @param {SharingGroupEditCreateInput} [sharingGroupEditCreateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharingGroupApi
     */
    createSharingGroup(sharingGroupEditCreateInput, options) {
        return (0, exports.SharingGroupApiFp)(this.configuration).createSharingGroup(sharingGroupEditCreateInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete sharing group
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharingGroupApi
     */
    deleteSharingGroup(id, options) {
        return (0, exports.SharingGroupApiFp)(this.configuration).deleteSharingGroup(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Edit sharing group
     * @param {string} id
     * @param {SharingGroupEditCreateInput} [sharingGroupEditCreateInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharingGroupApi
     */
    editSharingGroup(id, sharingGroupEditCreateInput, options) {
        return (0, exports.SharingGroupApiFp)(this.configuration).editSharingGroup(id, sharingGroupEditCreateInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all sharing groups
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharingGroupApi
     */
    getAllSharingGroups(filter, options) {
        return (0, exports.SharingGroupApiFp)(this.configuration).getAllSharingGroups(filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get sharing group by id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharingGroupApi
     */
    getSharingGroupById(id, options) {
        return (0, exports.SharingGroupApiFp)(this.configuration).getSharingGroupById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get sharing group shared documents
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharingGroupApi
     */
    getSharingGroupSharedDocuments(id, options) {
        return (0, exports.SharingGroupApiFp)(this.configuration).getSharingGroupSharedDocuments(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Import contacts to sharing group from csv
     * @param {string} id
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharingGroupApi
     */
    importContactsToSharingGroupFromCsv(id, file, options) {
        return (0, exports.SharingGroupApiFp)(this.configuration).importContactsToSharingGroupFromCsv(id, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unshare all documents with sharing group
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharingGroupApi
     */
    unshareAllDocumentsWithSharingGroup(id, options) {
        return (0, exports.SharingGroupApiFp)(this.configuration).unshareAllDocumentsWithSharingGroup(id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SharingGroupApi = SharingGroupApi;
